module.exports = __webpack_public_path__ + "img/icon_bottom_3.ff5df1df.png";